export default __webpack_public_path__ + "static/media/style2.948ff16e.svg";